// components/ProcessUnitSelector.js
import React from 'react';

const ProcessUnitSelector = ({ activeUnits, setActiveUnits }) => {
  // Handle checkbox changes to activate/deactivate units
  const handleUnitToggle = (unitName) => {
    setActiveUnits({
      ...activeUnits,
      [unitName]: !activeUnits[unitName]
    });
  };

  // Handle utility type selection (rankine cycle or heat medium)
  const handleUtilityTypeChange = (type) => {
    setActiveUnits({
      ...activeUnits,
      utilities: type
    });
  };

  return (
    <div className="process-unit-selector">
      <p className="unit-info">
        Select which process units are present in your gas processing plant:
      </p>
      
      <div className="unit-grid">
        <div className="unit-item">
          <input
            type="checkbox"
            id="fieldCompression"
            checked={activeUnits.fieldCompression}
            onChange={() => handleUnitToggle('fieldCompression')}
          />
          <label htmlFor="fieldCompression">Field Compression</label>
        </div>
        
        <div className="unit-item">
          <input
            type="checkbox"
            id="inletSeparation"
            checked={activeUnits.inletSeparation}
            onChange={() => handleUnitToggle('inletSeparation')}
          />
          <label htmlFor="inletSeparation">Inlet Separation</label>
        </div>
        
        <div className="unit-item">
          <input
            type="checkbox"
            id="inletCompression"
            checked={activeUnits.inletCompression}
            onChange={() => handleUnitToggle('inletCompression')}
          />
          <label htmlFor="inletCompression">Inlet Compression</label>
        </div>
        
        <div className="unit-item">
          <input
            type="checkbox"
            id="stabilisation"
            checked={activeUnits.stabilisation}
            onChange={() => handleUnitToggle('stabilisation')}
          />
          <label htmlFor="stabilisation">Stabilisation</label>
        </div>
        
        <div className="unit-item">
          <input
            type="checkbox"
            id="wasteWaterDisposal"
            checked={activeUnits.wasteWaterDisposal}
            onChange={() => handleUnitToggle('wasteWaterDisposal')}
          />
          <label htmlFor="wasteWaterDisposal">Waste Water Disposal</label>
        </div>
        
        <div className="unit-item">
          <input
            type="checkbox"
            id="sweetening"
            checked={activeUnits.sweetening}
            onChange={() => handleUnitToggle('sweetening')}
          />
          <label htmlFor="sweetening">Sweetening (Amine)</label>
        </div>
        
        <div className="unit-item">
          <input
            type="checkbox"
            id="dehydration"
            checked={activeUnits.dehydration}
            onChange={() => handleUnitToggle('dehydration')}
          />
          <label htmlFor="dehydration">Dehydration</label>
        </div>
        
        <div className="unit-item">
          <input
            type="checkbox"
            id="dewpoint"
            checked={activeUnits.dewpoint}
            onChange={() => handleUnitToggle('dewpoint')}
          />
          <label htmlFor="dewpoint">Dewpoint/Deepcut</label>
        </div>
        
        <div className="unit-item">
          <input
            type="checkbox"
            id="fractionation"
            checked={activeUnits.fractionation}
            onChange={() => handleUnitToggle('fractionation')}
          />
          <label htmlFor="fractionation">Fractionation</label>
        </div>
        
        <div className="unit-item">
          <input
            type="checkbox"
            id="salesCompression"
            checked={activeUnits.salesCompression}
            onChange={() => handleUnitToggle('salesCompression')}
          />
          <label htmlFor="salesCompression">Sales Compression</label>
        </div>
      </div>
      
      <div className="utilities-section">
        <p>Utilities:</p>
        <div className="utility-options">
          <div className="utility-option">
            <input
              type="radio"
              id="rankine"
              name="utilities"
              checked={activeUnits.utilities === 'rankine'}
              onChange={() => handleUtilityTypeChange('rankine')}
            />
            <label htmlFor="rankine">Rankine Cycle</label>
          </div>
          
          <div className="utility-option">
            <input
              type="radio"
              id="heatMedium"
              name="utilities"
              checked={activeUnits.utilities === 'heatMedium'}
              onChange={() => handleUtilityTypeChange('heatMedium')}
            />
            <label htmlFor="heatMedium">Heat Medium</label>
          </div>
          
          <div className="utility-option">
            <input
              type="radio"
              id="noUtilities"
              name="utilities"
              checked={activeUnits.utilities === 'none'}
              onChange={() => handleUtilityTypeChange('none')}
            />
            <label htmlFor="noUtilities">None</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessUnitSelector;